<template>
  <div
    v-if="errors.length"
    :class="$style.root"
  >
    <div :class="$style.errorWrap">
      <span @click="closeModal" :class="$style.closeBtn"></span>
      <div
        v-for="(error, index) in errors"
        :key="index"
        :class="$style.error"
      >
        {{ error }}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ErrorsList',
    props: {
      errors: {
        type: Array,
        default: () => [],
      },
    },
    methods: {
      closeModal() {
        this.$store.dispatch('calendar/resetErrors');
      },
    },
  };
</script>

<style
  lang="scss"
  module
>
  .root {
    background-color: $colorWhite;
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.08);
    position: fixed;
    z-index: 999999;
    top: 40px;
    right: 40px;
    border-radius: 10px;
    @include media('xs') {
      right: 10px;
      left: 10px;
      top: 30px;
    }
  }
  .errorWrap{
    width: 350px;
    padding: 20px 40px 30px 20px;
    position: relative;
    @include media('xs') {
      width: auto;
    }
  }
  .closeBtn{
    position: absolute;
    display: block;
    content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 10 10' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M4.07595 4.80123L0 8.50692L1.52161 10L4.9954 5.88699L8.47839 10L10 8.50692L5.9227 4.8L9.99043 1.55344L8.5379 0L4.99539 3.81002L1.4621 0L0.00957383 1.55344L4.07593 4.7989L4.07491 4.8L4.07595 4.80123Z' fill='black'/%3E%3C/svg%3E");
    cursor: pointer;
    right: 10px;
    top: 10px;
  }

  .error {
    @include typography(20px, 24px);
    text-align: left;

    & + & {
      margin-top: 5px;
    }
  }
</style>
